import { Documento } from '../../models/Documento';
export const listaDocumentos: Documento[] = [
  {
      id: 1,
      titulo: 'Instructivo de llenado Planilla 1 - EVALUAR-ME',
      descripcion: 'Instructivo de llenado Planilla 1 - EVALUAR-ME',
      urlpdf: 'https://drive.google.com/file/d/1TZqZZ2Xb8yv6VaBIL5O_ISJD6lJr7Cgq/view?usp=sharing'
  }
]
